import React, { useCallback, useEffect, useState } from 'react'
import Slider from './bannerSlider'
import DeliveryProcess from './deliveryProcess'
import ShopCategorySlider from './shopCategorySlider'
import AboutUs from './aboutUs'
import VirtualTryOn from './virtualTryon'
import LatestProducts from './latestProducts'
import Testimonials from './testimonials'
import homeApi from 'services/home'
import { showLoader, hideLoader } from 'redux/loader/actions'
import { showSnackbar } from 'redux/snackbar/actions'
import { useDispatch } from 'react-redux'

const Home = () => {
  const dispatch = useDispatch()
  const [sliderProcess, setSliderProcess] = useState([])
  const [deliveryProcess, setDeliveryProcess] = useState([])
  const [aboutProcess, setAboutProcess] = useState([])
  const [tryonProcess, setTryonProcess] = useState([])
  const [shopbycatProcess, setShopByCatProcess] = useState([])
  const [testimonials, setTestimonials] = useState([])
  const [latestProducts, setLatestProducts] = useState([])

  // Get delivery process details api
  const getUserDetails = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setDeliveryProcess(res?.data?.data?.results)
      } else {
        setDeliveryProcess([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      // dispatch(
      //   showSnackbar({
      //     message: err?.response?.data?.message || "Failed to fetch data",
      //     autoHideDuration: 3000,
      //     anchorOrigin: {
      //       vertical: "top",
      //       horizontal: "right",
      //     },
      //     variant: "error",
      //   })
      // );
      console.log('Get delivery process details Api', err)
    }
    homeApi.getDeliveryProcess().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Get Banner process details api
  const getBannerDetails = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setSliderProcess(res?.data?.data?.results)
      } else {
        setSliderProcess([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get banner list Api', err)
    }
    homeApi.getBannerProcess().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Get About details api
  const getAboutDetails = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setAboutProcess(res?.data?.data?.results)
      } else {
        setAboutProcess([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get about  details Api', err)
    }
    homeApi.getAbout().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //Get TryOn Details API
  const getTryonDetails = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setTryonProcess(res?.data?.data?.results)
      } else {
        setTryonProcess([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get tryon details Api', err)
    }
    homeApi.getTryon().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // GET SHOP_BY_CATEGORY
  const getShopbyCategoryDetails = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setShopByCatProcess(res?.data?.data?.results)
      } else {
        setShopByCatProcess([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get Shop by category details Api', err)
    }
    homeApi.getShopbyCategory().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // GET TESTIMONIALS
  const getTestimonials = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setTestimonials(res?.data?.data?.results)
      } else {
        setTestimonials([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get Shop by category details Api', err)
    }
    homeApi.getTestimonial().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // GET  LATEST PRODUCTS//
  const getLatestProductDetails = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setLatestProducts(res?.data?.data?.results)
      } else {
        setLatestProducts([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get Shop by category details Api', err)
    }
    homeApi.getLatestProducts().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getUserDetails()
    getBannerDetails()
    getAboutDetails()
    getTryonDetails()
    getShopbyCategoryDetails()
    getTestimonials()
    getLatestProductDetails()
  }, [
    getUserDetails,
    getBannerDetails,
    getAboutDetails,
    getTryonDetails,
    getShopbyCategoryDetails,
    getTestimonials,
    getLatestProductDetails,
  ])

  return (
    <>
      <Slider sliderProcess={sliderProcess} />
      <DeliveryProcess deliveryProcess={deliveryProcess} />
      <ShopCategorySlider shopbycatProcess={shopbycatProcess} />
      <AboutUs aboutProcess={aboutProcess} />
      {/* <VirtualTryOn tryonProcess={tryonProcess} /> */}
      <LatestProducts latestProducts={latestProducts} />
      <Testimonials testimonials={testimonials} />
    </>
  )
}

export default Home
